<div class="row">
  <div class="col-12">
    <h1 class="h4 mb-3">Flow Tracking</h1>
  </div>
</div>

<div class="sr-only" aria-live="polite">{{ status_message }}</div>

<flow-tracking-cards></flow-tracking-cards>

<flow-tracking-chart></flow-tracking-chart>

<div class="row">
  <div class="col-lg-12 stretch-card">
    <div class="card">
      <div class="d-flex flex-wrap justify-content-between align-items-end card-header mb-4 mb-md-3">
        <h2 class="h5 card-title font-semibold mb-2 mb-md-0">Flow readings</h2>

        <div class="header-actions d-flex flex-wrap align-items-end">

          <date-range-picker (applyRange)="onDateRangeChange($event)"></date-range-picker>

          <modal (trackingResponse)="onUpdateTabularData($event)"></modal>

        </div>
      </div>

      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-bordered">
            <caption class="sr-only">Flow tracking entries for tanker water deliveries</caption>
            <thead>
              <tr>
                <th scope="col">Driver Name</th>
                <th scope="col">Truck No:</th>
                <th scope="col">Timestamp</th>
                <th scope="col">Location</th>
                <th scope="col">Total Volume</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="tracking_rows.length === 0">
                <td colspan="6">No flow readings to display.</td>
              </tr>
              <tr *ngFor="let row of tracking_rows">
                <td>{{ row.driver_name }}</td>
                <td>{{ row.truck_number }}</td>
                <td>{{ row.timestamp }}</td>
                <td>{{ row.location || '—' }}</td>
                <td>{{ row.receive_volume !== '' && row.receive_volume != null ? row.receive_volume + ' litre' : '—' }}</td>
                <td>
                  <div class="action-buttons" role="group"
                    [attr.aria-label]="'Row actions for ' + row.driver_name">
                    <button *ngIf="row.action === 'start'" type="button" class="btn btn-danger btn-sm" (click)="stopFlowTracking(row.device_id)">
                      Stop
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>